// Ability / Art score math. In Ars Magica, a score of N costs 5 * N*(N+1)/2
// XP. Arts use 1*N*(N+1)/2 (no 5× multiplier). We store raw XP so the user
// can spend fractional advancement cleanly.

export function abilityScoreFromXp(xp: number): number {
  // score s such that 5 * s*(s+1)/2 <= xp < 5 * (s+1)*(s+2)/2
  let s = 0;
  while (5 * ((s + 1) * (s + 2)) / 2 <= xp) s++;
  return s;
}

export function xpForAbilityScore(score: number): number {
  return (5 * score * (score + 1)) / 2;
}

export function artScoreFromXp(xp: number): number {
  let s = 0;
  while (((s + 1) * (s + 2)) / 2 <= xp) s++;
  return s;
}

export function xpForArtScore(score: number): number {
  return (score * (score + 1)) / 2;
}

export function characteristicPointCost(value: number): number {
  // +1 = 1pt, +2 = 3pts, +3 = 6pts; negatives refund the same amounts.
  const abs = Math.abs(value);
  const cost = (abs * (abs + 1)) / 2;
  return value >= 0 ? cost : -cost;
}
